// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WpUq","importantInfo":"styles_importantInfo__hq8ks"};